import React, { useState } from 'react';
import './Login.css';
import { IoPerson } from "react-icons/io5";
import { TbLockPassword } from "react-icons/tb";
import { MdOutlineArrowOutward } from "react-icons/md";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        loginType: 'SUPER_ADMIN'
    });
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const getRouteForUserType = (userType) => {
        const routeMap = {
            'Super Admin': '/super-admin/dashboard',
            'Branch Office': '/branch-office/dashboard',
            'Counsellor': '/counsellor/dashboard',
            'Application Processor': '/application-processor/dashboard',
            'Front Office': '/front-office/dashboard',
            'Students': '/student-info/dashboard'
        };
        return routeMap[userType] || '/login';
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            // Map the loginType to the expected API values
            const userTypeMap = {
                'SUPER_ADMIN': 'Super Admin',
                'BRANCH_OFFICE': 'Branch Office',
                'COUNSELLOR': 'Counsellor',
                'APPLICATION_PROCESSOR': 'Application Processor',
                'FRONT_OFFICE': 'Front Office',
                'STUDENTS': 'Students'
            };

            const payload = {
                email: formData.username,
                password: formData.password,
                user_type: userTypeMap[formData.loginType] || 'Super Admin'
            };

            const response = await axios.post('https://bmrbackend.dynastymaker.com/api/login', payload);
            
            if (response.data.status === 'success') {
                // Save token and user info to local storage
                localStorage.setItem('authToken', response.data.token);
                localStorage.setItem('userType', response.data.user.user_type);
                localStorage.setItem('userEmail', response.data.user.email);
                
                // Redirect to the appropriate route based on user type
                const redirectPath = getRouteForUserType(response.data.user.user_type);
                navigate(redirectPath);
            } else {
                setError(response.data.message || 'Login failed');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'An error occurred during login');
            console.error('Login error:', err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <div className="logo-container">
                        <div className="logo-circle">
                            LOGO
                        </div>
                    </div>
                    <h2 className="text-center mb-4">Welcome Back</h2>
                </div>
                
                {error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}
                
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="username" className="form-label">Username</label>
                        <div className="input-group">
                            <span className="input-group-text"><IoPerson /></span>
                            <input 
                                type="text" 
                                className="form-control" 
                                id="username"
                                name="username"
                                placeholder="Enter username"
                                value={formData.username}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Password</label>
                        <div className="input-group">
                            <span className="input-group-text"><TbLockPassword /></span>
                            <input 
                                type="password" 
                                className="form-control" 
                                id="password"
                                name="password"
                                placeholder="Enter password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="mb-4">
                        <label htmlFor="loginType" className="form-label">Login As</label>
                        <select 
                            className="form-select form-select-lg"
                            id="loginType"
                            name="loginType"
                            value={formData.loginType}
                            onChange={handleChange}
                        >
                            <option value="SUPER_ADMIN">Super Admin</option>
                            <option value="BRANCH_OFFICE">Branch Office</option>
                            <option value="COUNSELLOR">Counsellor</option>
                            <option value="APPLICATION_PROCESSOR">Application Processor</option>
                            <option value="FRONT_OFFICE">Front Office</option>
                            <option value="STUDENTS">Students</option>
                        </select>
                    </div>
                    
                    <button 
                        type="submit" 
                        className="btn btn-outline-primary w-100 btn-lg login-btn"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        ) : (
                            <>
                                Login <MdOutlineArrowOutward />
                            </>
                        )}
                    </button>
                    
                    <div className="text-center mt-3">
                        <a href="#forgot-password" className="text-decoration-none">Forgot Password?</a>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login;